import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"
import { useStore } from "@/store"

import adloggs from "@/assets/lsp_logos/adloggs.png"
import lsn from "@/assets/lsp_logos/lsn.png"
//import mp2 from "@/assets/lsp_logos/mp2_logo.png"
import ola from "@/assets/lsp_logos/ola.png"
import pidge from "@/assets/lsp_logos/pidge.png"
import porter from "@/assets/lsp_logos/porter.png"
import shadowFax from "@/assets/lsp_logos/shadowfax.png"
import zypp from "@/assets/lsp_logos/zypp.png"
import telyport from "@/assets/lsp_logos/telyport.png"
import supr from "@/assets/lsp_logos/supr.png"
import shiprocket from "@/assets/lsp_logos/shiprocket.png"
import yulu from "@/assets/lsp_logos/yulu.png"
import qwqer from "@/assets/lsp_logos/qwqer.png"
import delhivery from "@/assets/lsp_logos/delhivery.png"
import defaultLsp from "@/assets/lsp_logos/lsp_default.png"
import { Order } from "./interfaces"
import dayjs from "dayjs"
import magicpin from "@/assets/lsp_logos/magicpin.png"
import mfleet from "@/assets/lsp_logos/mfleet.png"
import blitznow from "@/assets/lsp_logos/blitznow.png"
import ekbharat from "@/assets/lsp_logos/ekbharat.png"
import uber from "@/assets/lsp_logos/uber.png"
import borzo from "@/assets/lsp_logos/borzo.png"
import mrdelivery from "@/assets/lsp_logos/mrdelivery.png"
import airxy from "@/assets/lsp_logos/Airxy.png"
import bounce from "@/assets/lsp_logos/Bounce.png"
import tev from "@/assets/lsp_logos/TEV.png"
import bijliride from "@/assets/lsp_logos/Bijliride.png"
import dot from "@/assets/lsp_logos/DOT.png"
import gig4u from "@/assets/lsp_logos/gig4u.svg"
import indiapost from "@/assets/lsp_logos/indiapost.png"
import ekart from "@/assets/lsp_logos/ekart.png"
import rapido from "@/assets/lsp_logos/rapido.png"

export const apiHost = /localhost/.test(window.location.hostname) ? "http://localhost:8000" : import.meta.env.VITE_ENV === 'PROD' || /netlify\.app/.test(window.location.hostname) ? "https://ondc-logistics.prorouting.in" : "https://preprod.logistics-buyer.prorouting.in"
export const googleApiKey = 'AIzaSyBYJUasU8DCQjLmcCZlIYR0YsvzWRm_0sg'
export const SHIKHAR_HOME = import.meta.env.VITE_ENV === 'PROD' || /netlify\.app/.test(window.location.hostname) ? 'https://shikhar-fa2b7.web.app/' : 'https://shikar-5e94a.web.app'

export const is_shikhar_account = (accountId?: string) => {
  if (!accountId) return false
  return accountId.trim().toUpperCase().startsWith('SHK')
}

export const is_bigbasket_account = (accountId?: string) => {
  if (!accountId) return false
  return accountId.trim().toLowerCase().includes('bigbasket')
}

// Substring match catches both 'rebelfoods' and 'rebelfoods_preprod' in one check, same as
// is_bigbasket_account does for its own prod/variant account ids.
export const is_rebelfoods_account = (accountId?: string) => {
  if (!accountId) return false
  return accountId.trim().toLowerCase().includes('rebelfoods')
}

export const is_swiggy_account = (accountId?: string) => {
  if (!accountId) return false
  const id = accountId.trim().toLowerCase()
  return id.includes('swiggy') || id === 'instamart'
}

// Intercity is still a pilot, so the Hyperlocal / Intercity toggle on the add order form is only
// offered to these accounts. Everyone else stays hyperlocal and never declares a package size.
const INTERCITY_ENABLED_ACCOUNTS = new Set(['demointercity', 'mp2', 'mp2_preprod'])
export const is_intercity_enabled_account = (accountId?: string) => {
  if (!accountId) return false
  return INTERCITY_ENABLED_ACCOUNTS.has(accountId.trim().toLowerCase())
}

// Bulk order upload (Add Bulk Order / Download Labels on the orders page) is only offered to these
// accounts. The backend endpoint itself is not gated, so this is the only place to add an account.
const BULK_ORDER_ENABLED_ACCOUNTS = new Set(['mp2', 'mp2_preprod', 'yadasutra', 'bouncehsr', 'bouncedailydelhi', 'bouncetgf', 'primecut'])
export const is_bulk_order_enabled_account = (accountId?: string) => {
  if (!accountId) return false
  return BULK_ORDER_ENABLED_ACCOUNTS.has(accountId.trim().toLowerCase())
}

export const LSP_REPORT_ACCOUNT_BPP_MAP: Record<string, string> = {
  ekbharatdemo: 'prod-ondc.ekbharatfleet.com',
  olademo:'ondc-lsp.olacabs.com',
  qwqerdemo:'ondc.qwqer.in',
  uberdemo:'logistics-ondc-gateway.uber.com',
  
}

export const getLspReportBppId = (accountId?: string) => {
  if (!accountId) return undefined
  return LSP_REPORT_ACCOUNT_BPP_MAP[accountId.trim().toLowerCase()]
}

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const Api = <T>(url: string, method: 'POST' | 'GET' | 'PUT' | 'DELETE', body?: any, headers?: { [k: string]: string }) => {
  let apiParams: { method: 'POST' | 'GET' | 'PUT' | 'DELETE', headers: { [k: string]: string }, body?: string } = {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...(headers || {})
    },
  }

  if (body) {
    apiParams.body = JSON.stringify(body)
  }

  return fetch(`${/^https?:\//.test(url) ? '' : apiHost}${url}`, apiParams)
    .then(async resp => {
      if (resp.status === 401 && !url.includes('verifyOTP')) {
        useStore.getState().clearAuth()
        window.location.reload()
        throw { message: 'Unauthorized' }
      }

      const responseText = await resp.text()
      let responseBody: any = responseText

      if (responseText) {
        try {
          responseBody = JSON.parse(responseText)
        } catch {
          responseBody = responseText
        }
      } else {
        responseBody = null
      }

      if (!resp.ok) {
        const message = typeof responseBody === 'string'
          ? responseBody
          : responseBody?.message || responseBody?.error || resp.statusText || `Request failed with status ${resp.status}`
        throw {
          status: resp.status,
          message,
          data: responseBody
        }
      }

      if (responseBody && typeof responseBody === 'object' && responseBody.status === 0) {
        // Backends aren't consistent about the error-text key on a status:0 body - some use
        // `message`, this one (Prosquad edit/close passthrough) uses `error`. Without this,
        // callers doing `err.message` get an object rather than a string (see the .catch
        // normaliser below), which crashes trying to render it as toast/JSX text and takes
        // the whole page down via the router's error boundary instead of showing the error.
        throw { ...responseBody, message: responseBody.message || responseBody.error || 'Something went wrong' }
      }

      return responseBody as T
    })
    .catch(err => {
      if (err && typeof err === 'object' && 'message' in err) {
        return Promise.reject(err)
      }
      return Promise.reject({ message: err })
    })
}
export const getLogo = (provider?: string) => {
  if (!provider) {
    return ''
  }
  switch (true) {
    case /pidge/i.test(provider):
      return pidge
    case /loadshare/i.test(provider):
      return lsn
    case /porter/i.test(provider):
      return porter
    case /adloggs/i.test(provider):
      return adloggs
    case /shadowfax/i.test(provider):
      return shadowFax
    case /ola/i.test(provider):
      return ola
    case /zypp/i.test(provider):
      return zypp
    case /telyport/i.test(provider):
      return telyport
    case /supr/i.test(provider):
      return supr
    case /shiprocket/i.test(provider):
      return shiprocket
    case /yulu/i.test(provider):
      return yulu
    case /qwqer/i.test(provider):
      return qwqer
    case /delhivery/i.test(provider):
      return delhivery
    case /magicpin/i.test(provider):
      return magicpin
    case /mfleet/i.test(provider):
      return mfleet
    case /blitz/i.test(provider):
      return blitznow
    case /ekbharat/i.test(provider):
      return ekbharat
    case /uber/i.test(provider):
      return uber
    case /borzo/i.test(provider):
      return borzo
    case provider === 'mrdelivery.ondc-lsp.prosquad.ai':
      return mrdelivery
    case /airxy/i.test(provider):
      return airxy
    case /bounce/i.test(provider):
      return bounce
    case /tev/i.test(provider):
      return tev
    case /bijliride/i.test(provider):
      return bijliride
    case /dot/i.test(provider):
      return dot
    case /gig4u/i.test(provider):
      return gig4u
    case /indiapost/i.test(provider):
      return indiapost
    case /rapido/i.test(provider):
      return rapido
    case /ekart/i.test(provider):
      return ekart
    default:
      return defaultLsp
  }
}


const LSP_NAME_MAP: Record<string, string> = {
  'prod.ondc.adloggs.com': 'Adloggs',
  'ondc.blitznow.in': 'Blitz',
  'borzo-ondc.com': 'Borzo',
  'ondc.delhivery.com': 'Delhivery',
  'delhivery.ondc-lsp.mp2.in': 'Delhivery',
  'ondc.prod.dispatchos.io': 'DispatchNetwork',
  'ekart.ondc-lsp.prorouting.in': 'eKart',
  'prod-ondc.ekbharatfleet.com': 'EkBharat',
  'lsp-adapter.gle-prod.aarambh.cloud': 'GoodLife',
  'ondc.goodmove.in': 'Goodmove',
  'indiapost.ondc-lsp.prorouting.in': 'IndiaPost',
  'ondc.loadshare.net': 'Loadshare',
  'webapi.magicpin.in/oms_partner/ondc/logistics/seller/fleet_lokendra_4161': 'Magicpin',
  'ekta.mfleet.in/oms_partner/ondc/logistics/seller/fleet_ekta': 'Mfleet',
  'ondc-lsp.olacabs.com': 'OLA',
  'ola.ondc-lsp.prorouting.in': 'OLA',
  'ondc.picoxpress.com': 'PicoXpress',
  'ondc.pidge.in': 'Pidge',
  'ondc.theporter.in': 'Porter',
  'porter.ondc-lsp.mp2.in': 'Porter',
  'airxy.ondc-lsp.prosquad.ai': 'PRO-Airxy',
  'apollo.ondc-lsp.prosquad.ai': 'PRO-Apollo LSP',
  'bijliride.ondc-lsp.prosquad.ai': 'PRO-Bijliride',
  'bounce.ondc-lsp.prosquad.ai': 'PRO-Bounce',
  'carebazar.ondc-lsp.prosquad.ai': 'PRO-Carebazar',
  'dealscoder.ondc-lsp.prosquad.ai': 'PRO-Dealscoder',
  'dmn.ondc-lsp.prosquad.ai': 'PRO-DMN',
  'dot.ondc-lsp.prosquad.ai': 'PRO-DOT',
  'gig4u.ondc-lsp.prosquad.ai': 'PRO-Gig4U',
  'hire1.ondc-lsp.prosquad.ai': 'PRO-Hire1',
  'indiiserve.ondc-lsp.prosquad.ai': 'PRO-InDiiServe',
  'kpn.ondc-lsp.prosquad.ai': 'PRO-KRider',
  'localit.ondc-lsp.prosquad.ai': 'PRO-Localit',
  'mrdelivery.ondc-lsp.prosquad.ai': 'PRO-Mr Delivery',
  'neuson.ondc-lsp.prosquad.ai': 'PRO-Neuson',
  'peaklift.ondc-lsp.prosquad.ai': 'PRO-Peaklift',
  'shippin.ondc-lsp.prosquad.ai': 'PRO-Shippin',
  'tev.ondc-lsp.prosquad.ai': 'PRO-TEV',
  'vstaff.ondc-lsp.prosquad.ai': 'PRO-VStaff',
  'zippkart.ondc-lsp.prosquad.ai': 'PRO-Zippkart',
  'logistic.getgrun.co': 'Prune',
  'ondc.qwqer.in': 'Qwqer',
  'rapido.ondc-lsp.mp2.in': 'Rapido',
  'ondc.scooton.app': 'Scooton',
  'flash-api.shadowfax.in': 'Shadowfax',
  'shadowfax.ondc-lsp.mp2.in': 'Shadowfax',
  'ondc.shiprocket.in': 'Shiprocket',
  'ondc.suprdaily.com': 'Supr',
  'ondc.suprdaily.in': 'Supr',
  'ondc.telyport.com': 'Telyport',
  'logistics-ondc-gateway.uber.com': 'Uber',
  'yumove.yulu.bike': 'Yulu',
  'ondc.zypp.app': 'Zypp'
}

export const getLspName = (bbpId?: string, providerId?: string) => {
  if (!bbpId) return providerId ?? ''
  return LSP_NAME_MAP[bbpId] ?? (providerId ? providerId : bbpId)
}

export const cancellationIdReasonMapping: { [k: string]: string } = {
  "001": "Price of one or more items have changed due to which buyer was asked to make additional payment - 001",
  "002": "One or more items in the Order not available - 002",
  "003": "Product available at lower than order price - 003",
  "005": "Merchant rejected the order - 005",
  "006": "Order not shipped as per buyer app SLA - 006",
  "007": "Pickup ETA breach - 007",
  "008": "Order / fulfillment not ready for pickup - 008",
  "010": "Buyer wants to modify details - 010",
  "011": "Buyer not found or cannot be contacted - 011",
  "012": "Buyer does not want product any more - 012",
  "013": "Buyer refused to accept delivery - 013",
  "014": "Address not found - 014",
  "015": "Buyer not available at location - 015",
  "016": "Accident / rain / strike / vehicle issues - 016",
  "017": "Order delivery delayed or not possible - 017",
  "018": "Delivery delayed or not possible - 018",
  "020": "Lost in transit - 020",
  "997": "Order could not be created at LSP - 997"
}


export const internalCancellationIdReasonMapping: { [k: string]: string } = {
  "005": "Merchant Rejected - 005",
  "006": "Rider not moving - 006",
  "008": "Pickup not ready - 008"
}


export const atDeliveryCancellationIdReasonMapping: { [k: string]: string } = {
  "126": "Customer not reachable",
  "128": "Customer calling rider to a different location",
  "127": "Customer doesn't want the product anymore"
}

// Reasons an ops user can pick while triggering a buyer support callback to the rider. These are the
// same issues a rider can raise themselves. Keys must stay in sync with RIDER_SUPPORT_CALLBACK_REASONS
// on the backend, which maps them to the issueCode the LSP expects.
export const riderSupportReasonMapping: { [k: string]: string } = {
  customer_not_reachable: "Customer not reachable",
  unable_to_update_status: "Unable to update status (picked up / delivered)",
  item_oos: "Item out of stock / system issue",
  store_closed: "Store is closed",
  store_location_issue: "Problem finding or accessing the store",
  others: "Others"
}

export const copyTextToClipboard = async (text: string): Promise<boolean> => {
  const isSecureContext = typeof window !== 'undefined' && window.isSecureContext
  if (typeof navigator !== 'undefined' && navigator.clipboard && isSecureContext) {
    try {
      await navigator.clipboard.writeText(text)
      return true
    } catch {
      // Fallback to legacy approach below.
    }
  }

  try {
    const textarea = document.createElement('textarea')
    textarea.value = text
    textarea.setAttribute('readonly', '')
    textarea.style.position = 'fixed'
    textarea.style.top = '-1000px'
    textarea.style.opacity = '0'
    document.body.appendChild(textarea)
    textarea.focus()
    textarea.select()
    const didCopy = document.execCommand('copy')
    document.body.removeChild(textarea)
    return didCopy
  } catch {
    return false
  }
}

export const copyOrderDataToClipboard = async (order: Order): Promise<boolean> => {
  let keys: (keyof Order)[] = ['orderId', 'clientOrderId', 'networkOrderId', 'sellerOrderId', 'orderState', 'providerId', 'riderName', 'riderNumber', 'trackingUrl', 'awbNumber', 'pickupName']

  if (order.orderState === 'At-pickup') {
    keys.push('atpickupAt')
  } else if (order.orderState === 'Agent-assigned') {
    keys.push('assignedAt')
  } else if (order.orderState === 'Order-picked-up') {
    keys.push('pickedupAt')
  } else if (order.orderState === 'Order-delivered') {
    keys.push('deliveredAt')
  } else if (order.orderState === 'At-delivery') {
    keys.push('atdeliveryAt')
  } else if (order.orderState === 'Cancelled') {
    keys.push('cancelledAt')
    keys.push('cancelledBy')
  } else if (order.orderState === 'RTO-Initiated') {
    keys.push('rtoPickedupAt')
  } else if (order.orderState === 'RTO-Disposed' || order.orderState === 'RTO-Delivered') {
    keys.push('rtoDeliveredAt')
  }

  const text = keys.map(e => {
    if (e === 'providerId') return `LSP : ${getLspName(order.bppId || order['f.bppId'], order.providerId)}`
    return `${e} : ${order[e] && /At$/.test(e) ? dayjs(order[e].toString()).format('HH:mm') : order[e]}`
  }).join("\n")
  return copyTextToClipboard(text)
}

// Used by the gig group header (data-table.tsx) - same header shown on both the Orders page's
// gig grouping and the gig info page, so this one function covers the copy button on both.
export const copyGigDataToClipboard = async (gig: {
  gigId: string
  gigName?: string
  gigTime?: string
  riderName?: string
  gigStatus?: string
  lspPayout?: number
  orders: Order[]
}): Promise<boolean> => {
  const header = [
    `Gig Id : ${gig.gigId}`,
    gig.gigName ? `Gig Name : ${gig.gigName}` : undefined,
    gig.gigTime ? `Timing : ${gig.gigTime}` : undefined,
    `Rider : ${gig.riderName || 'Rider not assigned'}`,
    gig.gigStatus ? `Status : ${gig.gigStatus}` : undefined,
    gig.lspPayout != null ? `LSP Payout : ₹${gig.lspPayout}` : undefined,
    `Orders : ${gig.orders.filter(o => o.orderState === 'Order-delivered').length}/${gig.orders.length} delivered`,
  ].filter(Boolean).join("\n")

  const ordersByState = new Map<string, string[]>()
  gig.orders.forEach(order => {
    const state = order.orderState || 'Unknown'
    const ids = ordersByState.get(state)
    if (ids) ids.push(order.orderId)
    else ordersByState.set(state, [order.orderId])
  })
  const orderLines = [...ordersByState.entries()]
    .map(([state, orderIds]) => `${state}:\n${orderIds.join("\n")}`)
    .join("\n\n")

  return copyTextToClipboard(`${header}\n\n${orderLines}`)
}

// Used by the Gigs list page - that row is a per-gig summary from /webui/gig/list, with no
// underlying order list to break down (unlike copyGigDataToClipboard above), so this just copies
// the summary fields themselves.
export const copyGigSummaryToClipboard = async (gig: {
  gigId: string
  storeName?: string
  gigTime?: string
  riderName?: string
  lspName?: string
  gigStatus: string
  lspPayout?: number
  numOfOrders: number
  totalWorkingDuration?: number
  minServiceTimeMet?: number
}): Promise<boolean> => {
  const text = [
    `Gig Id : ${gig.gigId}`,
    gig.storeName ? `Store : ${gig.storeName}` : undefined,
    gig.gigTime ? `Timing : ${gig.gigTime}` : undefined,
    `Rider : ${gig.riderName || 'Rider not assigned'}`,
    gig.lspName ? `LSP : ${gig.lspName}` : undefined,
    `Status : ${gig.gigStatus}`,
    `Orders : ${gig.numOfOrders}`,
    gig.lspPayout != null ? `LSP Payout : ₹${gig.lspPayout}` : undefined,
    gig.totalWorkingDuration != null ? `Working Duration : ${gig.totalWorkingDuration} min` : undefined,
    gig.minServiceTimeMet != null ? `Min Service Time : ${gig.minServiceTimeMet ? 'Met' : 'Not Met'}` : undefined,
  ].filter(Boolean).join("\n")
  return copyTextToClipboard(text)
}

export const mapLink = (order: Order): string | undefined => {
  if (order.pickupLatitude && order.pickupLongitude && order.dropLatitude && order.dropLongitude) {
    return `https://www.google.com/maps/dir/?api=1&origin=${order.pickupLatitude},${order.pickupLongitude}&destination=${order.dropLatitude},${order.dropLongitude}&travelmode=driving`
  }
}


const escapeRegExp = (value: string) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

export const formatAddress = (address: string, components?: { longText: string, types?: string[] }[]) => {
  let city = ''
  let state = ''
  let pincode = ''

  // Google omits `types` altogether on components it can't classify (eg. a plain
  // street number), so it can never be dereferenced directly.
  const componentList = components || []

  for (let i = 0; i < componentList.length; i++) {
    const types = componentList[i].types || []

    if (types.includes('locality')) {
      city = componentList[i].longText
    }

    if (types.includes('postal_code')) {
      pincode = componentList[i].longText
    }

    if (types.includes('administrative_area_level_1')) {
      state = componentList[i].longText
    }
  }

  const stripPart = (value: string, part: string) => part ? value.replace(new RegExp(`,\\s*${escapeRegExp(part)}`, 'i'), '') : value
  const modifiedAddress = stripPart(stripPart((address || '').replace(/,\s*india/i, ''), state), city)
  const addressSplit = modifiedAddress.split(/\s*,\s*/)
  let addrLine1: string[] = []
  let addrLine2: string[] = []

  let line1Complete = false

  for (let i = 0; i < addressSplit.length; i++) {
    if (!line1Complete && [...addrLine1, addressSplit[i]].join(',').length < modifiedAddress.length / 2) {
      addrLine1.push(addressSplit[i])
    } else if (!line1Complete) {
      line1Complete = true
    }

    if (line1Complete) {
      addrLine2.push(addressSplit[i])
    }
  }

  return { line1: addrLine1.join(', '), line2: addrLine2.join(', '), city, pincode, state }
}

export const featureEnvironmentStatus = (feature: string) => {
  if (feature === 'readyToShip') {
    if (import.meta.env.VITE_ENV === 'PROD') {
      return false
    } else {
      return true
    }
  }
  if (feature === 'slotOrder') {
    return /preprod/i.test(window.location.hostname)
  }

  return false
}

export const states = ['Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh', 'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jammu and Kashmir',
  'Goa', 'Jharkhand', 'Karnataka', 'Kerala', 'Madhya Pradesh', 'Maharashtra', 'Manipur', 'Meghalaya', 'Mizoram', 'Nagaland', 'Odisha', 'Punjab',
  'Rajasthan', 'Sikkim', 'Tamil Nadu', 'Telangana', 'Tripura', 'Uttarakhand', 'Uttar Pradesh', 'West Bengal', 'Andaman and Nicobar Islands',
  'Chandigarh', 'Dadra and Nagar Haveli and Daman and Diu', 'New Delhi', 'Lakshadweep', 'Puducherry']

export const roundOff = (value: number, precision: number) => {
  if (precision === 0) {
    return Math.round(value).toString()
  } else {
    return /\./.test(value.toString()) ? value.toFixed(precision) : value.toString()
  }
}

export const formatStepDuration = (durationMs: number) => {
  const totalSeconds = Math.max(0, Math.round(durationMs / 1000))
  const days = Math.floor(totalSeconds / 86400)
  const hours = Math.floor((totalSeconds % 86400) / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const seconds = totalSeconds % 60

  if (days > 0) return `${days}d${hours ? ` ${hours}h` : ''}`
  if (hours > 0) return `${hours}h${minutes ? ` ${minutes}m` : ''}`
  if (minutes > 0) return `${minutes}m${seconds ? ` ${seconds}s` : ''}`
  return `${seconds}s`
}

export const generateOtp = () => {
  return Math.floor(1000 + Math.random() * 9000).toString()
}


export const splitAddressText = (address: string) => {
  const modifiedAddress = address.replace(/,\s*india/i, '').replace(new RegExp(`(${states.join('|')})`, 'gi'), '')
  const addressSplit = modifiedAddress.split(/\s*,\s*/)
  let addrLine1: string[] = []
  let addrLine2: string[] = []

  let line1Complete = false

  for (let i = 0; i < addressSplit.length; i++) {
    if (!line1Complete && addressSplit[i] && [...addrLine1, addressSplit[i]].join(',').length < modifiedAddress.length / 2) {
      addrLine1.push(addressSplit[i])
    } else if (!line1Complete) {
      line1Complete = true
    }

    if (line1Complete && addressSplit[i]) {
      addrLine2.push(addressSplit[i])
    }
  }

  return [addrLine1.join(', '), addrLine2.join(', ')]
}

export const generateRandomString = () => {
  return Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2, 7);
}

export const orderStatus: { [k: string]: number } = {
  'Created': 0,
  'UnFulfilled': 1,
  'Pending': 2,
  'Searching-for-Agent': 3,
  'Agent-assigned': 4,
  'At-pickup': 5,
  'Order-picked-up': 6,
  'Out-for-delivery': 7,
  'At-delivery': 8,
  'Order-delivered': 9,
  'Cancelled': 10,
  'RTO-Initiated': 11,
  'RTO-Disposed': 12,
  'RTO-Delivered': 13
}

export const paytmStatesMapping: { [k: string]: string } = {
  'Created': 'Searching for rider',
  'UnFulfilled': 'Searching for rider',
  'Pending': 'Searching for rider',
  'Searching-for-Agent': 'Searching for rider',
  'Agent-assigned': 'Rider Assigned',
  'At-pickup': 'Arrived at pickup ',
  'Order-picked-up': 'Order picked',
  'Out-for-delivery': 'Out for delivery',
  'At-delivery': 'Reached delivery location',
  'Order-delivered': 'Delivered',
  'Cancelled': 'Cancelled',
  'RTO-Initiated': 'Returned',
  'RTO-Disposed': 'Returned',
  'RTO-Delivered': 'Returned'
}

export const searchSubStr = (searchData: string, options: string[]) => {
  if (!searchData) {
    return [];
  }
  return options.filter(
    (eachValue) =>
      (eachValue || "")
        .toString()
        .toUpperCase()
        .replace(/\s|_/g, "")
        .indexOf(
          searchData
            .toString()
            .toUpperCase()
            .replace(/\s|_/g, "")
        ) > -1
  )
}

export const isOrderCancellable = (orderState: string, isSuperAdmin: boolean, accountId?: string, orderReadyAt?: string) => {
  if (is_bigbasket_account(accountId) && orderReadyAt) return false
  if (is_swiggy_account(accountId) && (orderState === 'Order-picked-up' || orderState === 'At-delivery')) return false
  return ['Created', 'Pending', 'Accepted', 'UnFulFilled', 'Searching-for-Agent', 'Agent-assigned', 'At-pickup', 'UnFulfilled'].includes(orderState) || ((orderState === 'At-delivery' || orderState === 'Order-picked-up') && isSuperAdmin)
}

const REALLOCATABLE_ORDER_STATES = ['Pending', 'Searching-for-Agent', 'Agent-assigned', 'At-pickup']

// Re-Allocate is turned off entirely for BigBasket accounts — re-allocation for them is driven
// from BigBasket's own systems, so the button stays disabled regardless of order state.
export const isOrderReallocatable = (orderState: string, unfulfillEnabled: boolean, accountId?: string, isSuperAdmin?: boolean) => {
  if (is_bigbasket_account(accountId)) return false
  if (!unfulfillEnabled && !isSuperAdmin) return false
  return REALLOCATABLE_ORDER_STATES.includes(orderState)
}
